<template>
  <v-tooltip top :disabled="disabledTooltip">
    <template #activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <div class="d-flex">
          <div v-if="showCashRegister" class="d-flex justify-start">
            <v-icon :color="cashRegisterColor"> mdi-{{ icon }} </v-icon>
          </div>
          <div class="d-flex justify-center w-100">
            <span v-if="showValue"> ${{ number_format(value) }}&nbsp; </span>
            <span v-if="showPendingText"> {{ pendingText }} </span>
          </div>
        </div>
      </div>
      <div v-if="showActionLink" class="text-decoration-underline text-blue">
        <a @click="actionLink"> {{ actionLinkText }} </a>
      </div>
    </template>
    <!-- Text Tooltip -->
    <slot />
  </v-tooltip>
</template>

<script>
  import helpers from '@/mixins/helpers.js';

  export default {
    name: 'RegisterCash',
    mixins: [helpers],
    props: {
      actionLinkText: {
        type: String,
        default: 'Detalles',
      },
      showValue: {
        type: Boolean,
        default: true,
      },
      showActionLink: {
        type: Boolean,
        default: true,
      },
      value: {
        type: Number,
        default: 0,
      },
      cashRegisterColor: {
        type: String,
        default: 'gray',
      },
      showCashRegister: {
        type: Boolean,
        default: true,
      },
      showPendingText: {
        type: Boolean,
        default: true,
      },
      pendingText: {
        type: String,
        default: 'Pendiente',
      },
      icon: {
        type: String,
        default: 'cash-register',
      },
      disabledTooltip: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      actionLink() {
        this.$emit('actionLink', true);
      },
    },
  };
</script>

<style scoped>
  /* Tus estilos aquí */

  /**  */
</style>
